
export enum SetOrder {
    ReleaseDate = 'ReleaseDate',
    Name = 'Name',
    Block = 'Block',
    NumCards = 'NumCards'
}

export enum SetOrderFormat {
    ReleaseDate = 'Release Date',
    Name = 'Name',
    Block = 'Block/Group',
    NumCards = 'Number of Cards'
}

export enum SetType {
    Any = 'Any',
    Cube = 'Cube',
    Archenemy = 'Archenemy',
    Box = 'Box',
    Commander = 'Commander',
    Conspiracy = 'Conspiracy',
    Core = 'Core',
    DuelDeck = 'Duel Deck',
    Expansion = 'Expansion',    
    FromTheVault = 'From The Vault',
    Funny = 'Funny',
    Masterpiece = 'Masterpiece',
    Masters = 'Masters',
    Memorabilia = 'Memorabilia<',    
    Planechase = 'Planechase',
    PremiumDeck = 'Premium Deck',
    Promo = 'Promo',
    Starter = 'Starter',
    Token = 'Token',
    TreasureChest = 'Treasure Chest',
    Vanguard = 'Vanguard'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/constants/setFormats.ts